import React from 'react';

import { COLOR, ENTITY_COLOR } from '@/theme/colors';
import { SVGIconProps } from '@/types/svg';

const EquinetTeams: React.FC<SVGIconProps> = ({
    width = 240,
    color = ENTITY_COLOR.teams,
}) => {
    return (
        <svg
            width={width}
            id="Layer_3"
            data-name="Layer 3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 239.89 65.59"
        >
            <g id="Layer_1" data-name="Layer 1">
                <g>
                    <path
                        fill={color}
                        d="M65.59,32.8C65.59,14.68,50.91,0,32.8,0S0,14.68,0,32.8s14.68,32.8,32.8,32.8,32.8-14.68,32.8-32.8"
                    />
                    <path
                        fill={COLOR.white}
                        d="M20.98,47.01c-4.66,1.59-7.23.38-7.23.38l-5.55-11s3.02.79,7.16-2.59c4.16-3.39,9.2-18.96,9.2-18.96l8.24,16.33s-6.69,14.05-11.82,15.84"
                    />
                    <path
                        fill={COLOR.white}
                        d="M44.62,47.01c4.66,1.59,7.24.38,7.24.38l5.54-11s-3.02.79-7.16-2.59c-4.14-3.39-9.19-18.96-9.19-18.96l-8.24,16.33s6.7,14.05,11.82,15.84"
                    />
                    <path
                        fill={COLOR.white}
                        d="M32.8,64.1c-17.26,0-31.3-14.04-31.3-31.3S15.54,1.5,32.8,1.5s31.3,14.04,31.3,31.3-14.04,31.3-31.3,31.3M32.8,2.84C16.28,2.84,2.83,16.28,2.83,32.8s13.44,29.96,29.96,29.96,29.96-13.44,29.96-29.96S49.32,2.84,32.8,2.84"
                    />
                    <g>
                        <polygon
                            fill={color}
                            points="99.28 6.5 99.28 10.07 86.5 10.07 86.5 12.8 98.54 12.8 98.54 15.93 86.5 15.93 86.5 18.73 99.44 18.73 99.44 22.3 81.76 22.3 81.76 6.5 99.28 6.5"
                        />
                        <path
                            fill={color}
                            d="M126.1,19.2l-1.68,3.25-1.87-1.37c-.66.57-1.45.9-2.61,1.14-.97.21-2.49.26-6.56.26-3.32,0-5.71-.09-6.61-.26-1.75-.33-2.75-1-3.37-2.16-.57-1.14-.73-2.28-.73-5.33s.05-3.75.36-4.84c.45-1.68,1.37-2.58,3.18-3.1,1.19-.33,2.7-.45,5.69-.45,5.95,0,7.58.07,8.86.4,1.73.43,2.7,1.37,3.18,3.13.26.85.33,1.87.33,4.36,0,2.09-.05,2.77-.21,3.79l2.06,1.19ZM119.44,15.31c.02-.59.02-.85.02-1.26,0-3.81-.07-3.86-6.47-3.86-5.24,0-5.47.17-5.47,4.2,0,2.44.24,3.32.97,3.72.85.45,1.52.5,6.07.5,1.97,0,2.84-.05,3.58-.19l-5.24-2.92,1.9-3.2,4.64,3.01Z"
                        />
                        <path
                            fill={color}
                            d="M133.5,6.5v7.82c0,1.73,0,1.78.07,2.2.24,1.78,1.02,2.13,4.62,2.13s4.6-.09,5.19-.54c.47-.36.71-1.04.73-2.25q.02-.36.02-2.11v-7.25h4.81v8.29c.05,3.91-.28,5.07-1.68,6.33-1.14.88-2.56,1.26-4.62,1.28-.73.02-1.16.02-2.11.02l-1.8.02c-4.46-.02-5.33-.07-6.49-.38-2.87-.88-3.63-2.37-3.56-7.06V6.5h4.81Z"
                        />
                        <rect
                            fill={color}
                            x="152.93"
                            y="6.5"
                            width="4.81"
                            height="15.81"
                        />
                        <polygon
                            fill={color}
                            points="161.86 6.5 169.52 6.5 179.09 18.51 178.98 6.5 183.53 6.5 183.53 22.3 175.8 22.3 166.37 10.41 166.49 22.3 161.86 22.3 161.86 6.5"
                        />
                        <polygon
                            fill={color}
                            points="205.14 6.5 205.14 10.07 192.37 10.07 192.37 12.8 204.4 12.8 204.4 15.93 192.37 15.93 192.37 18.73 205.3 18.73 205.3 22.3 187.63 22.3 187.63 6.5 205.14 6.5"
                        />
                        <polygon
                            fill={color}
                            points="215.04 10.41 208.01 10.41 208.01 6.5 226.89 6.5 226.89 10.41 219.86 10.41 219.86 22.3 215.04 22.3 215.04 10.41"
                        />
                        <path
                            fill={color}
                            d="M81.65,27.62h12.09c3.06,0,3.84.09,4.83.59,1.59.78,2.18,2.23,2.18,5.21s-.54,4.57-1.85,5.38c-.92.57-1.99.74-4.74.74h-7.73v3.89h-4.79v-15.81ZM93.43,35.7c1.97,0,2.54-.43,2.54-1.92,0-1.9-.47-2.32-2.54-2.32h-6.99v4.24h6.99Z"
                        />
                        <path
                            fill={color}
                            d="M104.16,27.62h13.63c2.8,0,4.03.24,4.93,1,.92.73,1.35,2.09,1.35,4.22,0,2.94-.71,4.1-2.72,4.55,1.97.33,2.56,1.16,2.51,3.55v2.49h-4.88v-1.97c-.02-1.71-.5-2.06-2.65-2.01h-7.37v3.98h-4.79v-15.81ZM116.46,35.59c2.32,0,2.77-.28,2.77-1.85,0-1.02-.09-1.45-.4-1.78-.36-.38-.76-.45-2.2-.45h-7.68v4.08h7.51Z"
                        />
                        <polygon
                            fill={color}
                            points="145.47 27.62 145.47 31.2 132.7 31.2 132.7 33.93 144.74 33.93 144.74 37.06 132.7 37.06 132.7 39.85 145.64 39.85 145.64 43.43 127.96 43.43 127.96 27.62 145.47 27.62"
                        />
                        <polygon
                            fill={color}
                            points="149.19 27.62 156.82 27.62 162.58 38.12 168.32 27.62 175.9 27.62 175.9 43.43 171.21 43.43 171.45 31.22 164.43 43.43 160.59 43.43 153.69 31.22 153.84 43.43 149.19 43.43 149.19 27.62"
                        />
                        <rect
                            fill={color}
                            x="180.02"
                            y="27.62"
                            width="4.81"
                            height="15.81"
                        />
                        <path
                            fill={color}
                            d="M193.75,27.62v7.82c0,1.73,0,1.78.07,2.2.24,1.78,1.02,2.13,4.62,2.13s4.6-.09,5.19-.55c.47-.36.71-1.04.73-2.25q.02-.36.02-2.11v-7.25h4.81v8.29c.05,3.91-.28,5.07-1.68,6.33-1.14.88-2.56,1.26-4.62,1.28-.73.02-1.16.02-2.11.02l-1.8.02c-4.46-.02-5.33-.07-6.49-.38-2.87-.88-3.63-2.37-3.56-7.06v-8.51h4.81Z"
                        />
                        <polygon
                            fill={color}
                            points="213.18 27.62 220.81 27.62 226.57 38.12 232.3 27.62 239.89 27.62 239.89 43.43 235.2 43.43 235.43 31.22 228.42 43.43 224.58 43.43 217.68 31.22 217.82 43.43 213.18 43.43 213.18 27.62"
                        />
                        <polygon
                            fill={color}
                            points="81.65 50.56 90.8 50.56 90.8 52.51 84.26 52.51 84.26 54.22 90.46 54.22 90.46 56.18 84.26 56.18 84.26 59.17 81.65 59.17 81.65 50.56"
                        />
                        <path
                            fill={color}
                            d="M102,50.59c1.33.25,1.98.93,2.16,2.31.05.35.08,1.05.08,2.09,0,2.08-.22,2.92-.96,3.53-.52.44-1.24.65-2.49.7-.47.03-1.62.04-2.45.04-2.05,0-3.1-.04-3.62-.14-.96-.17-1.51-.53-1.83-1.16-.34-.63-.41-1.27-.41-3.15,0-1.45.03-1.81.18-2.39.25-.92.75-1.41,1.72-1.69.72-.21,1.51-.26,3.79-.26,2.48,0,3.24.03,3.85.13M95.57,52.88c-.35.27-.45.7-.45,1.94s.1,1.73.43,2c.35.28.78.34,2.75.34,2.26,0,2.73-.08,3.02-.49.25-.31.31-.75.31-1.9,0-2.17-.04-2.2-3.27-2.2-1.92,0-2.45.06-2.79.31"
                        />
                        <path
                            fill={color}
                            d="M106.31,50.56h7.43c1.52,0,2.2.13,2.69.54.5.4.74,1.14.74,2.3,0,1.6-.39,2.23-1.49,2.48,1.07.18,1.4.63,1.37,1.94v1.36h-2.66v-1.07c-.01-.93-.27-1.12-1.45-1.1h-4.02v2.17h-2.61v-8.62ZM113.01,54.9c1.27,0,1.51-.15,1.51-1.01,0-.56-.05-.79-.22-.97-.19-.21-.41-.24-1.2-.24h-4.19v2.22h4.1Z"
                        />
                        <polygon
                            fill={color}
                            points="125.62 52.69 121.78 52.69 121.78 50.56 132.08 50.56 132.08 52.69 128.24 52.69 128.24 59.17 125.62 59.17 125.62 52.69"
                        />
                        <polygon
                            fill={color}
                            points="143.29 50.56 143.29 52.51 136.33 52.51 136.33 53.99 142.89 53.99 142.89 55.7 136.33 55.7 136.33 57.22 143.38 57.22 143.38 59.17 133.75 59.17 133.75 50.56 143.29 50.56"
                        />
                        <path
                            fill={color}
                            d="M149.6,50.56h3.51l4.72,8.62h-2.87l-.85-1.54h-5.56l-.83,1.54h-2.97l4.85-8.62ZM153.19,55.84l-1.86-3.44-1.84,3.44h3.7Z"
                        />
                        <polygon
                            fill={color}
                            points="159.04 50.56 163.2 50.56 166.34 56.28 169.46 50.56 173.6 50.56 173.6 59.17 171.04 59.17 171.17 52.52 167.35 59.17 165.25 59.17 161.49 52.52 161.57 59.17 159.04 59.17 159.04 50.56"
                        />
                        <path
                            fill={color}
                            d="M178.28,56.42c.03.59.09.74.4.85.19.08.93.13,1.76.13,3.04,0,3.4-.09,3.4-.8,0-.35-.17-.61-.44-.7q-.28-.09-1.64-.1h-2.38c-1.59,0-2.25-.09-2.8-.38-.62-.32-.9-1.01-.9-2.18,0-1.55.44-2.21,1.68-2.51.7-.18,1.71-.25,3.59-.25,3.02,0,3.72.08,4.34.48.59.4.79.93.79,2.22h-2.56c0-.75-.26-.85-1.95-.85-.84,0-1.96.03-2.38.05-.7.05-.93.23-.93.72,0,.36.18.59.56.68.15.04.21.05,1.06.06h2.44c.23,0,1.39.04,1.83.06,1.64.08,2.29.8,2.29,2.53,0,1.59-.47,2.29-1.73,2.56-.65.14-1.93.22-3.8.22-2.98,0-3.64-.06-4.41-.45-.53-.26-.8-.92-.8-1.94,0-.08,0-.24.01-.43h2.57Z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default EquinetTeams;
